import { defineMessages } from 'react-intl';

/**
 * The copy of the song field of Releases and the Studio (designs release-kit k2, o1). The field only
 * shows the song. The master, the lyrics and the details change on the song page in Catalog.
 */
export const catalogSongFieldMessages = defineMessages({
  hintCatalog: { id: 'app.sml.promote.song.hintCatalog', defaultMessage: 'From your catalog' },
  hintMissing: { id: 'app.sml.promote.song.hintMissing', defaultMessage: '{title} has no master yet' },
  noSong: {
    id: 'app.sml.promote.song.noSong',
    defaultMessage: 'Pick a release first. Its master comes from your catalog.',
  },
  usesMaster: { id: 'app.sml.promote.song.usesMaster', defaultMessage: 'Uses the master in your catalog' },
  hookAt: { id: 'app.sml.promote.song.hookAt', defaultMessage: 'Hook at {time}' },
  masterLabel: { id: 'app.sml.promote.song.label.master', defaultMessage: 'Master' },
  lyricsLabel: { id: 'app.sml.promote.song.lyrics', defaultMessage: 'Lyrics' },
  detailsLabel: { id: 'app.sml.promote.song.label.details', defaultMessage: 'Details' },
  noMaster: { id: 'app.sml.promote.song.master.none', defaultMessage: 'No master yet' },
  masterFailed: {
    id: 'app.sml.promote.song.master.failed',
    defaultMessage: 'MUSIC24 cannot read the master of {title}.',
  },
  noLyrics: { id: 'app.sml.promote.song.noLyrics', defaultMessage: 'No lyrics' },
  lyricsPlain: { id: 'app.sml.promote.song.lyrics.plain', defaultMessage: 'Lyrics, not timed' },
  lyricsSyncing: { id: 'app.sml.promote.song.lyrics.syncing', defaultMessage: 'Syncing the lyrics' },
  lyricsTimed: { id: 'app.sml.promote.song.lyricsTimed', defaultMessage: 'Lyrics timed' },
  lyricsFailed: { id: 'app.sml.promote.song.lyrics.failed', defaultMessage: 'The lyric sync failed' },
  noDate: { id: 'app.sml.promote.song.details.noDate', defaultMessage: 'No release date' },
  noCover: { id: 'app.sml.promote.song.details.noCover', defaultMessage: 'No cover art' },
  addMaster: { id: 'app.sml.promote.song.cta.addMaster', defaultMessage: 'Add the master in Catalog' },
  replaceMaster: { id: 'app.sml.promote.song.cta.replaceMaster', defaultMessage: 'Replace the master in Catalog' },
  addLyrics: { id: 'app.sml.promote.song.cta.addLyrics', defaultMessage: 'Add the lyrics in Catalog' },
  fixTimes: { id: 'app.sml.promote.song.cta.fixTimes', defaultMessage: 'Fix the times in Catalog' },
  addDetails: { id: 'app.sml.promote.song.cta.addDetails', defaultMessage: 'Add the details in Catalog' },
  catalogNote: {
    id: 'app.sml.promote.song.catalogNote',
    defaultMessage: 'Change the master, the lyrics and the details in Catalog.',
  },
});
